import type { BoxProps } from '@chakra-ui/react';
import { HStack } from '@chakra-ui/react';
import { ProductBadge } from 'components/product/ProductBadge';
import type { ProductBullet } from 'types/cms/ProductBullet';

interface ProductBadgesProps extends BoxProps {
  productBullet?: ProductBullet;
  secondaryProductBullet?: ProductBullet;
  isPreorder?: boolean;
}

const isRenderable = (bullet?: ProductBullet) =>
  Boolean(bullet?.label && bullet?.style);

export function ProductBadges({
  productBullet,
  secondaryProductBullet,
  isPreorder,
  ...props
}: ProductBadgesProps) {
  const showPrimary = isRenderable(productBullet) || isPreorder;
  const showSecondary = isRenderable(secondaryProductBullet);

  if (!showPrimary && !showSecondary) {
    return null;
  }

  return (
    <HStack spacing="4xs" {...props}>
      {showPrimary && (
        <ProductBadge productBullet={productBullet} isPreorder={isPreorder} />
      )}
      {showSecondary && (
        <ProductBadge
          variant="outline"
          productBullet={secondaryProductBullet}
        />
      )}
    </HStack>
  );
}
